import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=edad9e60&scoped=true&lang=pug"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=edad9e60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edad9e60",
  null
  
)

export default component.exports